/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketScanResponseRestriction } from './TicketScanResponseRestriction';
import {
    TicketScanResponseRestrictionFromJSON,
    TicketScanResponseRestrictionFromJSONTyped,
    TicketScanResponseRestrictionToJSON,
} from './TicketScanResponseRestriction';
import type { ScanStatus } from './ScanStatus';
import {
    ScanStatusFromJSON,
    ScanStatusFromJSONTyped,
    ScanStatusToJSON,
} from './ScanStatus';
import type { TicketType } from './TicketType';
import {
    TicketTypeFromJSON,
    TicketTypeFromJSONTyped,
    TicketTypeToJSON,
} from './TicketType';
import type { ParsedTicketData } from './ParsedTicketData';
import {
    ParsedTicketDataFromJSON,
    ParsedTicketDataFromJSONTyped,
    ParsedTicketDataToJSON,
} from './ParsedTicketData';

/**
 * 
 * @export
 * @interface TicketScanResponse
 */
export interface TicketScanResponse {
    /**
     * Parsed play data for this scan: the numbers picked (per board) and per-draw winnings. Null when play data is unavailable for the scan.
     * @type {ParsedTicketData}
     * @memberof TicketScanResponse
     */
    parsedTicketData?: ParsedTicketData | null;
    /**
     * External system response for the scan. This will be the raw scan response (with sensitive data redacted) from the
     * CGS system that we sourced the scan from. The exact shape will be different depending on the CGS system.
     * @type {{ [key: string]: any; }}
     * @memberof TicketScanResponse
     */
    externalScanResponse?: { [key: string]: any; } | null;
    /**
     * 
     * @type {TicketScanResponseRestriction}
     * @memberof TicketScanResponse
     */
    restriction?: TicketScanResponseRestriction;
    /**
     * When the ticket was originally issued/printed (e.g., CDC date).
     * Populated by the ticket scanning backend when available.
     * @type {Date}
     * @memberof TicketScanResponse
     */
    ticketIssuedAt?: Date | null;
    /**
     * Details about the scan. If the scan had an error, the details of the error will be here
     * @type {string}
     * @memberof TicketScanResponse
     */
    details: string;
    /**
     * The cost of this ticket. If this is not supported by the ticket scanning plugin it will be null/undefined
     * @type {number}
     * @memberof TicketScanResponse
     */
    ticketCostInCents?: number | null;
    /**
     * Description of any additional non-monetary winnings from the ticket that come from the CGS system, like a free
     * scratch ticket.
     * 
     * Note this isn't intended for external promotional items related to a scan, but rather things integrated into the
     * CGS response.
     * @type {string}
     * @memberof TicketScanResponse
     */
    additionalWinnings?: string | null;
    /**
     * For tickets with multiple independent winning components, such as draw tickets that have winnings on multiple
     * different draws, this will contain the incremental win amounts for each of those winning components.
     * 
     * The total of all the values in this field will add up to the value of
     * @type {Array<number>}
     * @memberof TicketScanResponse
     */
    incrementalWinAmountsInCents: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof TicketScanResponse
     */
    winAmountInCents: number;
    /**
     * Name of the game being scanned, if available from the type of ticket and scanning integration
     * @type {string}
     * @memberof TicketScanResponse
     */
    gameName?: string | null;
    /**
     * The original game identifier from the scan source or provider. Populated when the input game ID
     * was not already a GDS UUID (i.e., it was an external provider's game ID that was resolved).
     * Null when the caller provided a GDS UUID directly or when no game ID was provided.
     * @type {string}
     * @memberof TicketScanResponse
     */
    externalGameId?: string | null;
    /**
     * GDS game UUID for the game this ticket belongs to. Null if the game could not be identified.
     * For external scans, the server resolves the provided game ID to a GDS UUID at storage time.
     * @type {string}
     * @memberof TicketScanResponse
     */
    gameId?: string | null;
    /**
     * Whether you have draw remaining on the ticket. This will always be false for tickets that aren't of type "DRAW".
     * @type {boolean}
     * @memberof TicketScanResponse
     */
    drawsRemaining: boolean;
    /**
     * Unique ID for this scan
     * @type {string}
     * @memberof TicketScanResponse
     */
    scanId: string;
    /**
     * A truncated segment of the original scanned barcode. Exactly how the barcode is truncated and how many characters
     * this contains will vary depending on the integration.
     * @type {string}
     * @memberof TicketScanResponse
     */
    truncatedBarcode?: string | null;
    /**
     * A cryptographic hash of the barcode value. This can be used to match different scans to see if they had the same
     * source barcode. This is a safe value to store in a consuming system, unlike the unencrypted source barcode.
     * @type {string}
     * @memberof TicketScanResponse
     */
    barcodeHash: string;
    /**
     * 
     * @type {Date}
     * @memberof TicketScanResponse
     */
    timestamp: Date;
    /**
     * 
     * @type {TicketType}
     * @memberof TicketScanResponse
     */
    ticketType: TicketType;
    /**
     * 
     * @type {ScanStatus}
     * @memberof TicketScanResponse
     */
    status: ScanStatus;
}



/**
 * Check if a given object implements the TicketScanResponse interface.
 */
export function instanceOfTicketScanResponse(value: object): value is TicketScanResponse {
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('incrementalWinAmountsInCents' in value) || value['incrementalWinAmountsInCents'] === undefined) return false;
    if (!('winAmountInCents' in value) || value['winAmountInCents'] === undefined) return false;
    if (!('drawsRemaining' in value) || value['drawsRemaining'] === undefined) return false;
    if (!('scanId' in value) || value['scanId'] === undefined) return false;
    if (!('barcodeHash' in value) || value['barcodeHash'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('ticketType' in value) || value['ticketType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function TicketScanResponseFromJSON(json: any): TicketScanResponse {
    return TicketScanResponseFromJSONTyped(json, false);
}

export function TicketScanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketScanResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'parsedTicketData': json['parsedTicketData'] == null ? undefined : ParsedTicketDataFromJSON(json['parsedTicketData']),
        'externalScanResponse': json['externalScanResponse'] == null ? undefined : json['externalScanResponse'],
        'restriction': json['restriction'] == null ? undefined : TicketScanResponseRestrictionFromJSON(json['restriction']),
        'ticketIssuedAt': json['ticketIssuedAt'] == null ? undefined : (new Date(json['ticketIssuedAt'])),
        'details': json['details'],
        'ticketCostInCents': json['ticketCostInCents'] == null ? undefined : json['ticketCostInCents'],
        'additionalWinnings': json['additionalWinnings'] == null ? undefined : json['additionalWinnings'],
        'incrementalWinAmountsInCents': json['incrementalWinAmountsInCents'],
        'winAmountInCents': json['winAmountInCents'],
        'gameName': json['gameName'] == null ? undefined : json['gameName'],
        'externalGameId': json['externalGameId'] == null ? undefined : json['externalGameId'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'drawsRemaining': json['drawsRemaining'],
        'scanId': json['scanId'],
        'truncatedBarcode': json['truncatedBarcode'] == null ? undefined : json['truncatedBarcode'],
        'barcodeHash': json['barcodeHash'],
        'timestamp': (new Date(json['timestamp'])),
        'ticketType': TicketTypeFromJSON(json['ticketType']),
        'status': ScanStatusFromJSON(json['status']),
    };
}

export function TicketScanResponseToJSON(value?: TicketScanResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'parsedTicketData': ParsedTicketDataToJSON(value['parsedTicketData']),
        'externalScanResponse': value['externalScanResponse'],
        'restriction': TicketScanResponseRestrictionToJSON(value['restriction']),
        'ticketIssuedAt': value['ticketIssuedAt'] == null ? undefined : ((value['ticketIssuedAt'] as any).toISOString()),
        'details': value['details'],
        'ticketCostInCents': value['ticketCostInCents'],
        'additionalWinnings': value['additionalWinnings'],
        'incrementalWinAmountsInCents': value['incrementalWinAmountsInCents'],
        'winAmountInCents': value['winAmountInCents'],
        'gameName': value['gameName'],
        'externalGameId': value['externalGameId'],
        'gameId': value['gameId'],
        'drawsRemaining': value['drawsRemaining'],
        'scanId': value['scanId'],
        'truncatedBarcode': value['truncatedBarcode'],
        'barcodeHash': value['barcodeHash'],
        'timestamp': ((value['timestamp']).toISOString()),
        'ticketType': TicketTypeToJSON(value['ticketType']),
        'status': ScanStatusToJSON(value['status']),
    };
}

